/****************************************************
 * Module Name:  labTestReport.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import { Container } from "@mui/material";
import React from "react";
import LabTestingComponent from "../common/labTestingComponent";
import NoPermission from "../common/noPermission";
import Constants from "../../utility/constants";
import { useEffect } from "react";
import { useState } from "react";

const LabTestReport = () => {
  const [access, setAccess] = useState(false);

  useEffect(() => {
    checkPermission();
  }, []);

  const checkPermission = () => {
    let allowed = Constants.USER_PERMISSION.find(
      (iPermission) =>
        iPermission.permissionid ===
        Constants.PERMISSIONS.REPORT_LABTEST_LABTEST
    ) !== undefined
    if (!allowed) {
      setAccess(true)
      return <NoPermission />
    }
  }
  return (
    <Container className="background" maxWidth="xxl">
      {
        access ? <NoPermission /> : (
          <LabTestingComponent
            closeStatus={true}
            reportLoad={true}
            userDropdown={true}
          />
        )}
    </Container>
  );
};

export default LabTestReport;
